import React from "react";
import { Filter, RotateCcw } from "lucide-react";

const ActivityFilters = ({
  activityTypes = [],
  selectedType,
  setSelectedType,
  selectedStatus,
  setSelectedStatus,
  selectedRatingStatus,
  setSelectedRatingStatus,
  dateFrom,
  setDateFrom,
  dateTo,
  setDateTo,
  resetFilters,
  onRefresh,
  loading = false,
}) => {
  return (
    <div className="bg-slate-50 border border-slate-200 rounded-xl p-3 mb-4 flex flex-wrap items-center gap-3 text-xs">
      <div className="flex items-center gap-1.5 text-slate-700 font-bold mr-1">
        <Filter className="w-4 h-4 text-blue-600" />
        <span>Filter Activities:</span>
      </div>

      {/* Activity Type */}
      <select
        value={selectedType}
        onChange={(e) => setSelectedType(e.target.value)}
        className="bg-white border border-slate-300 rounded-lg px-2.5 py-1.5 font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        <option value="">All Types</option>
        {activityTypes.map((t) => (
          <option key={t} value={t}>
            {t}
          </option>
        ))}
      </select>

      {/* Status (Approved / Rejected / Pending) */}
      <select
        value={selectedStatus}
        onChange={(e) => setSelectedStatus(e.target.value)}
        className="bg-white border border-slate-300 rounded-lg px-2.5 py-1.5 font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        <option value="">All Review Statuses</option>
        <option value="APPROVED">Approved ✅</option>
        <option value="REJECTED">Rejected ❌</option>
        <option value="PENDING">Pending ⏳</option>
      </select>

      {/* Date From */}
      <div className="flex items-center gap-1">
        <span className="text-slate-500 font-medium">From:</span>
        <input
          type="date"
          value={dateFrom}
          onChange={(e) => setDateFrom(e.target.value)}
          className="bg-white border border-slate-300 rounded-lg px-2 py-1 font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>

      {/* Date To */}
      <div className="flex items-center gap-1">
        <span className="text-slate-500 font-medium">To:</span>
        <input
          type="date"
          value={dateTo}
          onChange={(e) => setDateTo(e.target.value)}
          className="bg-white border border-slate-300 rounded-lg px-2 py-1 font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>

      {/* Reset */}
      {(selectedType || selectedStatus || selectedRatingStatus || dateFrom || dateTo) && (
        <button
          onClick={resetFilters}
          className="flex items-center gap-1 text-slate-600 hover:text-rose-600 font-semibold px-2 py-1 rounded-lg hover:bg-slate-100 transition-colors ml-auto"
        >
          <RotateCcw className="w-3.5 h-3.5" />
          <span>Reset</span>
        </button>
      )}
    </div>
  );
};

export default ActivityFilters;
